import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { logoutUser } from '../services/firebase';
import { LogIn, LogOut, Coins, Sparkles, UserCircle, Settings } from 'lucide-react';
import AuthModal from './AuthModal';

interface NavbarProps {
  onOpenProfile: () => void;
  onOpenHome: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onOpenProfile, onOpenHome }) => {
  const { user, credits } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 px-6 py-4 flex justify-between items-center backdrop-blur-md bg-gray-950/70 border-b border-white/5">
        <div className="flex items-center gap-2 cursor-pointer" onClick={onOpenHome}>
          <div className="bg-blue-600/20 p-2 rounded-lg border border-blue-500/30">
            <Sparkles className="w-5 h-5 text-blue-400" />
          </div>
          <span className="font-bold text-xl tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400">
            AutoSub DeskPro
          </span>
        </div>

        <div className="flex items-center gap-4">
          {user ? (
            <>
              <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-yellow-500/10 border border-yellow-500/20 rounded-full">
                <Coins className="w-4 h-4 text-yellow-400" />
                <span className="text-sm font-medium text-yellow-200">{credits} Credits</span>
              </div>
              
              <div className="flex items-center gap-3 pl-4 border-l border-white/10">
                <button 
                  onClick={onOpenProfile}
                  className="flex items-center gap-2 text-right group"
                >
                  <div className="hidden sm:block flex flex-col items-end">
                    <span className="text-xs font-medium text-gray-200 group-hover:text-blue-400 transition-colors">{user.displayName || 'User'}</span>
                    <span className="text-xs text-gray-500 truncate max-w-[150px]">{user.email}</span>
                  </div>
                  {user.photoURL ? (
                    <img 
                      src={user.photoURL} 
                      alt="Profile" 
                      className="w-9 h-9 rounded-full border border-gray-700 group-hover:border-blue-500 transition-colors object-cover"
                    />
                  ) : (
                    <div className="w-9 h-9 rounded-full bg-gray-800 flex items-center justify-center border border-gray-700 group-hover:border-blue-500 transition-colors">
                      <span className="text-sm font-bold text-white">{user.displayName ? user.displayName[0].toUpperCase() : 'U'}</span>
                    </div>
                  )}
                </button>
                <button 
                  onClick={logoutUser}
                  className="p-2 hover:bg-white/5 rounded-full text-gray-400 hover:text-white transition-colors"
                  title="Logout"
                >
                  <LogOut className="w-5 h-5" />
                </button>
              </div>
            </>
          ) : (
            <button 
              onClick={() => setShowAuthModal(true)}
              className="flex items-center gap-2 px-4 py-2 bg-white text-gray-950 rounded-lg font-semibold text-sm hover:bg-gray-200 transition-colors shadow-[0_0_15px_rgba(255,255,255,0.2)]"
            >
              <LogIn className="w-4 h-4" />
              Sign In
            </button>
          )}
        </div>
      </nav>

      <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} />
    </>
  );
};

export default Navbar;